import { useEffect } from 'react';
import { createSearchParams, Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import Page404 from './pages/Page404';

//auth
import { ForgotPasswordPage, LoginPage, NewPasswordPage, ResetPasswordPage } from './pages/auth';

//dashboard
import BookingTypesView from './components/dashboard/admin/invoice-booking-types/BookingTypesView';
import TicketSettingsView from './components/dashboard/tickets/TicketSettingsView';
import {
    AdminBudgets,
    AdvancedSearch,
    Catalog,
    CatalogItem,
    Census,
    CompletedRentals,
    CurrentRentals,
    DashboardHome,
    EmailRecipients,
    Emails,
    ExcelUpload,
    Facilities,
    Groups,
    Invoice,
    Invoices,
    InvoicingSettings,
    InvoicingVendors,
    Order,
    OrderGuide,
    OrderGuides,
    Orders,
    PendingRentals,
    PriceAccounts,
    PurchasingCategories,
    Rental,
    RentalCart,
    RentalCatalog,
    RentalCheckout,
    RentalOrder,
    RentalSettings,
    RentalSummary,
    RentalVendorsView,
    Reports,
    Shop,
    SingleUser,
    SiteRules,
    Statements,
    Subscriptions,
    SuperAdminReports,
    SystemNotices,
    Tasks,
    Ticket,
    Tickets,
    TransitionsDueDiligence,
    TransitionsForm,
    TransitionsHome,
    TransitionsInitialDueDiligence,
    TransitionsUsers,
    TransportRequestDetails,
    TransportsCalendar,
    TransportsSettings,
    User,
    Users,
    VendorCatalog,
    Vendors,
    WarehouseVendors,
} from './pages/dashboard';
import FacilityAccounts from './pages/dashboard/admin/FacilityAccounts';
import ReceivedEmails from './pages/dashboard/admin/ReceivedEmails';
import Contracts from './pages/dashboard/contracts/Contracts';
import Contract from './components/dashboard/contracts/ContractView';
import ContractsAITool from './pages/dashboard/contracts/ContractsAITool';
import Cart from './pages/dashboard/orders/new-order/Cart';
import Page403 from './pages/Page403';

// ----------------------------------------------------------------------

export default function Router() {
    //URLChangeTracker();
    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            //const amplitude = document.createElement('script');
            //amplitude.src = "https://cdn.amplitude.com/script/c0946555caf9a98edc8aad851a0dee94.js";
            //amplitude.onload = () => {
            //  window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));
            //  window.amplitude.init('c0946555caf9a98edc8aad851a0dee94', { "fetchRemoteConfig": true, "autocapture": true });
            //};
            //document.body.appendChild(amplitude);
            //return () => {
            //  document.body.removeChild(amplitude);
            //}
        }
        return () => {};
    }, []);

    const routes = useRoutes([
        {
            path: '/auth',
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to="/auth/login" />, index: true },
                { path: 'login', element: <LoginPage /> },
                { path: 'forgot-password', element: <ForgotPasswordPage />, search: createSearchParams({ email: '' }) },
                { path: 'new-password', element: <NewPasswordPage /> },
                { path: 'resetpassword', element: <ResetPasswordPage /> },
            ],
        },
        {
            path: '/dashboard',
            element: <DashboardLayout />,
            children: [
                { element: <Navigate to="/dashboard/home" />, index: true },
                { path: 'home', element: <DashboardHome /> },
                { path: 'advanced-search', element: <AdvancedSearch /> },
                { path: 'home/user/:id', element: <SingleUser />, search: createSearchParams({ id: '' }) },
                { path: 'orders/new-order/cart/:facilityId', element: <Cart /> },
                { path: 'orders/new-order/:facilityId', element: <Shop /> },
                { path: 'orders/:id', element: <Order />, search: createSearchParams({ id: '' }) },
                { path: 'orders', element: <Orders /> },
                { path: 'reports', element: <Reports /> },
                { path: 'contracts/active', element: <Contracts /> },
                { path: 'contracts/terminated', element: <Contracts /> },
                { path: 'contracts/pending-renew', element: <Contracts /> },
                { path: 'contracts/previous-owner', element: <Contracts /> },
                { path: 'contracts/ai-tool', element: <ContractsAITool /> },
                { path: 'contracts/:id', element: <Contract />, search: createSearchParams({ id: '', status: '' }) },

                { path: 'invoicing/new', element: <Invoices /> },
                { path: 'invoicing/pendingFilter', element: <Invoices /> },
                { path: 'invoicing/awaitingSubmission', element: <Invoices /> },
                { path: 'invoicing/invoicesInQueue', element: <Invoices /> },
                { path: 'invoicing/rejectedInvoices', element: <Invoices /> },
                { path: 'invoicing/pending', element: <Invoices /> },
                { path: 'invoicing/previous', element: <Invoices />, search: createSearchParams({ start: '', end: '' }) },
                { path: 'invoicing/complete', element: <Statements /> },
                { path: 'invoicing/incomplete', element: <Statements /> },
                { path: 'invoicing/vendors', element: <InvoicingVendors /> },
                { path: 'invoicing/settings', element: <InvoicingSettings /> },
                { path: 'invoicing/new/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/pendingFilter/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/awaitingSubmission/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/invoicesInQueue/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/rejectedInvoices/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/pending/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },
                { path: 'invoicing/previous/:id', element: <Invoice />, search: createSearchParams({ id: '' }) },

                { path: 'tickets/settings', element: <TicketSettingsView /> },
                { path: 'tickets/:id', element: <Ticket />, search: createSearchParams({ subticket: '' }) },
                { path: 'tickets', element: <Tickets /> },
                { path: 'admin/budgets', element: <AdminBudgets /> },
                { path: 'admin/catalog', element: <Catalog /> },
                { path: 'admin/catalog/:id', element: <CatalogItem />, search: createSearchParams({ id: '' }) },

                { path: 'admin/census', element: <Census /> },
                { path: 'admin/order-guides', element: <OrderGuides /> },
                { path: 'admin/order-guides/:id', element: <OrderGuide />, search: createSearchParams({ id: '' }) },
                { path: 'admin/users', element: <Users /> },
                { path: 'admin/facilities', element: <Facilities /> },
                { path: 'admin/users/:id', element: <User />, search: createSearchParams({ id: '' }) },
                { path: 'admin/purchasing-categories', element: <PurchasingCategories /> },
                { path: 'admin/emails', element: <Emails /> },
                { path: 'admin/received-emails', element: <ReceivedEmails /> },
                { path: 'admin/vendors', element: <Vendors /> },
                { path: 'admin/facility-accounts', element: <FacilityAccounts /> },
                { path: 'admin/system-notices', element: <SystemNotices /> },
                { path: 'super-admin/warehouse-vendors', element: <WarehouseVendors /> },
                { path: 'super-admin/facilities', element: <Facilities /> },
                { path: 'super-admin/email-recipients', element: <EmailRecipients /> },
                { path: 'super-admin/tasks', element: <Tasks /> },
                { path: 'super-admin/site-rules', element: <SiteRules /> },
                { path: 'super-admin/groups', element: <Groups /> },
                { path: 'super-admin/excel', element: <ExcelUpload /> },
                { path: 'super-admin/vendor-catalog', element: <VendorCatalog /> },
                { path: 'super-admin/reports', element: <SuperAdminReports /> },
                { path: 'super-admin/system-notices', element: <SystemNotices viewMain /> },
                { path: 'super-admin/price-accounts', element: <PriceAccounts /> },
                { path: 'super-admin/invoice-booking-types', element: <BookingTypesView /> },
                { path: 'transitions/home', element: <TransitionsHome /> },
                { path: 'transitions/users', element: <TransitionsUsers /> },
                { path: 'transitions/initial-due-diligence', element: <TransitionsInitialDueDiligence /> },
                { path: 'transitions/initial-due-diligence/:id', element: <TransitionsInitialDueDiligence /> },
                { path: 'transitions/due-diligence/:id', element: <TransitionsDueDiligence /> },
                { path: 'transitions/transition-form/:id', element: <TransitionsForm /> },
                { path: 'rentals/pending-rentals', element: <PendingRentals /> },
                { path: 'rentals/current-rentals', element: <CurrentRentals /> },
                { path: 'rentals/previous-rentals', element: <CompletedRentals /> },
                { path: 'rentals/rental-catalog', element: <RentalCatalog /> },
                { path: 'rentals/rental-vendors', element: <RentalVendorsView /> },
                { path: 'rentals/rental-settings', element: <RentalSettings /> },
                {
                    path: 'rentals/rental-order/:orderId/:orderStatus',
                    element: <RentalOrder />,
                    search: createSearchParams({ orderId: '', orderStatus: '' }),
                },
                {
                    path: 'rentals/new-rental',
                    element: <Rental />,
                    search: createSearchParams({ facilityId: '', category: '', residentId: '', subcategoryId: '' }),
                },
                {
                    path: 'rentals/rental-orders/rental-cart/:facilityId',
                    element: <RentalCart />,
                    search: createSearchParams({ facilityId: '', category: '', residentId: '' }),
                },
                {
                    path: 'rentals/new-rental/rental-cart/',
                    element: <RentalCart />,
                    search: createSearchParams({ facilityId: '', category: '', residentId: '' }),
                },
                {
                    path: 'rentals/new-rental/rental-checkout/:residentId',
                    element: <RentalCheckout />,
                    search: createSearchParams({ facilityId: '', category: '', residentId: '' }),
                },
                {
                    path: 'rentals/new-rental/rental-order-summary',
                    element: <RentalSummary />,
                    search: createSearchParams({ facilityId: '', category: '', residentId: '', orderNumber: '' }),
                },
                { path: 'admin/emails', element: <Emails /> },
                { path: 'admin/vendors', element: <Vendors />, search: createSearchParams({ tab: '' }) },
                { path: 'admin/subscriptions', element: <Subscriptions /> },
                { path: 'tickets/:id', element: <Ticket />, search: createSearchParams({ id: '', subticket: '' }) },
                { path: 'tickets', element: <Tickets /> },
                { path: 'transports/calendar', element: <TransportsCalendar /> },
                { path: 'transports/settings', element: <TransportsSettings /> },
                {
                    path: 'transports/request-details/:id/:date?',
                    element: <TransportRequestDetails />,
                    search: createSearchParams({ id: '', date: '' }),
                },
            ],
        },
        {
            element: <DashboardLayout />,
            children: [
                { element: <Navigate to="/dashboard/home" />, index: true },
                { path: '404', element: <Page404 /> },
                { path: '403', element: <Page403 /> },
                { path: '*', element: <Navigate to="/404" /> },
            ],
        },
        {
            path: '*',
            element: <Navigate to="/404" replace />,
        },
    ]);

    return routes;
}
